import cakeLpFarmingPools from "@/domain/cakeLpFarming/pools";
import token from "@/domain/cakeLpFarming/token";
import network from "@/domain/cakeLpFarming/network";
import rewardToken from "@/domain/cakeLpFarming/rewardToken";
import cakeLps from "@/domain/cakeLpFarming/cakeLps";

const store = {
  namespaced: true,
  state: {
    pools: cakeLpFarmingPools.map((pool, index) => {
      const cakeLp = cakeLps.find((cakeLp) => cakeLp.type == pool.type);

      return {
        title: pool.title,
        type: pool.type,
        temperature: pool.temperature,
        description: "No minimum",
        url: pool.url,
        NETWORK: network.name,
        CHAIN_ID: network.chainIds[0],
        coinSymbol: token.name,
        mainCoinImage: null,
        smallerCoinImage: null,
        minDepositAmount: `${0}`,
        totalLiqudity: 0,
        swapUrl: pool.swapUrl,
        pairUrl: pool.pairUrl,
        stakeTokenAddress: cakeLp.contractAddress,
        stakeTokenSymbol: cakeLp.name,
        stakeTokenDecimals: cakeLp.decimals,
        rewardTokenAddress: rewardToken.contractAddress,
        rewardTokenSymbol: rewardToken.name,
        rewardTokenDecimals: rewardToken.decimals,
        stakeContractAddress: pool.contractAddress,
        status: "ACTIVE",
        apy: 0,
        order: index + 1,
        isMaster: false,
        id: index + 1,
        createdAt: new Date(),
        updatedAt: new Date(),
        isFrozen: false,
        isFinished: false,
        account: {
          balance: `${0}`,
          earned: `${0}`,
          staked: `${0}`,
          isApproved: false,
        },
      };
    }),
  },
  getters: {},
  mutations: {
    updatePools(state, payload) {
      state.pools = payload;
    },
    approvePool(state, payload) {
      state.pools[payload].account.isApproved = true;
    },
  },
  actions: {
    updatePools({ commit }, payload) {
      commit("updatePools", payload);
    },
    approvePool({ commit }, payload) {
      commit("approvePool", payload);
    },
  },
};

export default store;
